import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { FormControl } from "@material-ui/core";

import { getChangedData, getDefaultWidgetName, getTagid } from "utils/utils";
import { InputErrorStrings, TagWidgetFormStrings, valueStrings, WidgetStrings } from "constants/constantStrings";
import { WIDGET_TITLE_INPUT_MAXIMUM } from "constants/globalConstants";
import { SYSTEMS_PAGES } from "constants/pages.constant";
import { WIDGET_TYPES } from "constants/widgets.type.const";

import CustomModal from "components/CustomModal";
import InputBox from "components/InputBox";
import { TextFieldValidator } from "components/InputBox/TextFieldValidator";
import TagDropdown from "components/TagDropdown";

export default function TagWidgetForm(props) {
  const [openModal, setOpenModal] = useState(true);
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const { tagsAsObj } = useSelector(state => state.tags);
  const { Header, page, tagsList, currentLayout, isEdit, onWidgetAction, Attributes } = props.data;
  const { Function } = Attributes || "";
  const isReportView = () => page.toLowerCase() === SYSTEMS_PAGES.REPORTS;
  const Tags = Attributes ? tagsAsObj[Attributes?.SystemTag[0]] : null;
  const widgetDefaultState = {
    Header: Header || getDefaultWidgetName(),
    Attributes: {
      Function: isReportView() ? Function || "min" : "",
      Comments: Attributes?.Comments || "",
      SystemTag: Tags
    }
  };
  const [widgetData, setWidgetData] = useState(widgetDefaultState);
  useEffect(() => setWidgetData(widgetDefaultState), [Header]);

  const levelTypesConfig = [
    { label: TagWidgetFormStrings.min, value: "min" },
    { label: TagWidgetFormStrings.max, value: "max" },
    { label: TagWidgetFormStrings.mean, value: "mean" }
  ];

  const closeModal = closeType => {
    setOpenModal(false);
    props.onClose(closeType);
  };

  const onTagChange = Tag => {
    const formData = { ...widgetData, Attributes: { ...widgetData.Attributes, SystemTag: Tag } };
    validateForm(formData);
  };

  const onTitleChange = Header => {
    const formData = { ...widgetData, Header };
    validateForm(formData);
  };

  const onLevelTypeChange = event => {
    const Function = event?.target?.value || " ";
    const formData = { ...widgetData, Attributes: { ...widgetData.Attributes, Function: Function } };
    validateForm(formData);
  };

  const validateForm = formData => {
    const { Header, Attributes } = formData;
    const { SystemTag, Function } = Attributes;
    let isFormValid = SystemTag?.TagId;
    if (isReportView()) {
      isFormValid = Header && Header.trim().length > 0 && isFormValid && Function;
    }
    setIsFormInvalid(!isFormValid);
    setWidgetData(formData);
  };

  const getDescription = () => (isReportView() ? TagWidgetFormStrings.reportDescription : TagWidgetFormStrings.dashboardDescription);

  const getTagPayload = () => {
    const { Header, Attributes } = widgetData;
    const { SystemTag, Function, Comments } = Attributes;
    const tag = new Array(SystemTag?.TagId);
    return {
      Type: WIDGET_TYPES.TAG,
      LayoutID: currentLayout.ID,
      Header,
      Attributes: { Function: Function, SystemTag: tag, Comments: Comments || "" }
    };
  };

  const getEditTagPaylod = () => {
    let param = getChangedData(widgetData, widgetDefaultState);
    param = getTagid(param.Attributes?.SystemTag, param);
    return { ...param, Id: props.data.Id, LayoutID: currentLayout.ID };
  };

  const submitReportTag = async () => {
    let payload = {};
    if (isEdit) {
      payload = getEditTagPaylod();
    } else {
      payload = getTagPayload();
      onWidgetAction("ADD_WIDGET", payload);
    }
    closeModal(payload);
  };
  const submitDashboardTag = async () => {
    let payload = {};
    if (isEdit) {
      payload = getEditTagPaylod();
    } else {
      payload = getTagPayload();
      onWidgetAction("ADD_WIDGET", null, null, payload);
    }
    closeModal(payload);
    setIsFormInvalid(false);
  };

  const onFormSubmit = () => {
    setIsFormInvalid(true);
    if (isReportView()) {
      submitReportTag();
    } else {
      submitDashboardTag();
    }
  };

  return (
    <>
      {openModal && (
        <CustomModal
          show={openModal}
          title={isEdit ? TagWidgetFormStrings.editTitle : TagWidgetFormStrings.addTitle}
          confirmBtnText={isEdit ? WidgetStrings.editWidget : WidgetStrings.addWidget}
          description={getDescription()}
          secondaryDescription={valueStrings.mandatoryField}
          close={closeModal}
          confirmBtnAction={onFormSubmit}
          confirmDisabled={isFormInvalid}
        >
          <div className="widget-form-container">
            {isReportView() && (
              <div className="form-group">
                <label className="bodyMainHeadingText" htmlFor="widgetTitle">
                  {WidgetStrings.widgetTitle}*
                </label>
                <InputBox
                  name="widgetTitle"
                  value={widgetData.Header}
                  placeholder={WidgetStrings.titlePlaceholder}
                  requiredMsg={InputErrorStrings.required}
                  onChange={onTitleChange}
                  validator={TextFieldValidator.ALPHANUMERIC_WITH_SPECIAL_CHARS}
                  maxLength={WIDGET_TITLE_INPUT_MAXIMUM}
                />
              </div>
            )}
            <div className="form-group">
              <label className="bodyMainHeadingText">{WidgetStrings.selectTag}*</label>
              <TagDropdown
                dropDownID="addTagDropdown"
                tagValue={widgetData.Attributes.SystemTag}
                tagList={tagsList}
                requiredMsg={InputErrorStrings.required}
                onTagChange={onTagChange}
              />
            </div>
            {isReportView() && (
              <FormControl>
                <label className="bodyMainHeadingText">{WidgetStrings.levelType}*</label>
                <div className="radio-group" onChange={onLevelTypeChange}>
                  {levelTypesConfig.map(level => (
                    <>
                      <label className="radiocontainer">
                        {level.label}
                        <input
                          className="radioLabel"
                          type="radio"
                          defaultChecked={widgetData.Attributes.Function === level.value}
                          value={level.value}
                          name="levelType"
                        />
                        <span className="radioButton" />
                      </label>
                    </>
                  ))}
                </div>
              </FormControl>
            )}
          </div>
        </CustomModal>
      )}
    </>
  );
}
